/*
 * Copyright (c) 2023 Bluemate B.V.
 */
import './style/bluemateButton.scss';
import './style/bluemateToggleButton.scss';

import React, {MouseEvent, MouseEventHandler, ReactNode, useState} from 'react';

import {OrnamentShape} from '@dvrd/dvr-controls';

import classNames from 'classnames';

import {BluemateControlColor, BluemateControlShape, BluemateControlSize} from '../../../util/types';

import BluemateButton from './bluemateButton';

interface Props {
    label: ReactNode;
    active?: boolean;
    defaultActive?: boolean;
    onToggle?: (active: boolean) => void;
    onClick?: MouseEventHandler;
    ornaments?: OrnamentShape | OrnamentShape[];
    disabled?: boolean;
    className?: string;
    labelClassName?: string;
    ornamentClassName?: string;
    secondary?: boolean;
    color?: BluemateControlColor;
    size?: BluemateControlSize;
    shape?: BluemateControlShape;
    id?: string;
}

export default function BluemateToggleButton({
    active,
    defaultActive = false,
    onToggle,
    className,
    disabled,
    onClick,
    ...rest
}: Props) {
    const [internalActive, setInternalActive] = useState(defaultActive);
    const isControlled = active !== undefined;
    const isActive = isControlled ? active : internalActive;

    const handleClick = (e: MouseEvent) => {
        if (disabled) return;

        const newValue = !isActive;
        if (!isControlled) {
            setInternalActive(newValue);
        }
        onToggle?.(newValue);
        onClick?.(e);
    };

    return (
        <BluemateButton
            {...rest}
            disabled={disabled}
            className={classNames(className, 'toggle-button', !isActive && 'inactive')}
            onClick={handleClick}
        />
    );
}
